export default {
  SET_MANNING_VESSELS(state, data) {
    state.manningVessels = data;
  },

  SET_LATEST_CUTOFF_DATE(state, data) {
    state.latestCutoffDate = data;
  },

  SET_ENTERPRISE_CREWS(state, data) {
    state.enterpriseCrews = data;
  },
};
